(function ($) {
	var inputSelector = '.js-clearable-input';
	var clearButtonSelector = '.js-clear-input-button';
	var $inputs = $(inputSelector);
	var $clearButtons = $(clearButtonSelector);

	var checkIfButtonShouldBeShown = function ($input) {
		var shouldShow = $input.val().length > 0;
		var $clearButton = $input.siblings(clearButtonSelector);

		if (shouldShow) {
			$clearButton.show();
		} else {
			$clearButton.hide();
		}
	};

	$inputs.on('input', function () {
		checkIfButtonShouldBeShown($(this));
	});

	$clearButtons.on('click', function () {
		var $input = $(this).siblings(inputSelector);
		$input.val('').trigger('input').focus();
	});

	$inputs.each(function (i, element) {
		checkIfButtonShouldBeShown($(element));
	});
})(jQuery);
